import { connect, MapDispatchToPropsFunction } from 'react-redux'
import {
  FeedFilterPeoplePopup,
  FeedFilterPeoplePopupStateProps,
  FeedFilterPeoplePopupDispatchProps,
  FeedFilterPeoplePopupOwnProps,
} from 'components/features/socialFeed/FeedfilterPopup/FeedFilterPeoplePopup'
import { State } from 'interfaces/state'
import {
  hidePopupFeedFilterActionCreator,
  registerPopupFeedFilterTimeoutActionCreator,
  selectFeedFilterActionCreator,
  getFollowedUsersActionCreator,
  resetFollowedUsersActionCreator,
} from 'actions/feedActions'
import { peersRelationSelector } from 'selectors/peergroupSelectors'
import { feedDataSelector, feedAppSelector } from 'selectors/feedSelectors'
import { setShownSidebarPaneActionCreator } from 'actions/sidebarActions'


const mapStateToProps = (state: State, _ownProps: FeedFilterPeoplePopupOwnProps): FeedFilterPeoplePopupStateProps => {
  const { isLoading, errorCode, pagination } = feedDataSelector(state).followedUsersLoading
  const links = pagination.pagination
  const hasMorePeople =
    !links          // no links when no first request
    || !!links.next // was requests & has next page

  return {
    hidePopupTimeoutId: state.app.feed.filterPopup.hideTimeoutId,
    peersRelation: peersRelationSelector(state),

    hasMore: hasMorePeople,
    isLoading: isLoading,
    followedPeopleIds: pagination.results,
    errorCode: errorCode,
    paginationLinks: links,
    shouldResetOnUnmount: feedAppSelector(state).shouldResetFollowedPeople,
  }
}

const mapDispatchToProps: MapDispatchToPropsFunction<
  FeedFilterPeoplePopupDispatchProps,
  FeedFilterPeoplePopupOwnProps
> = (dispatch, _ownProps) => ({
  onLoadMore: (links) => dispatch(
    getFollowedUsersActionCreator.request({ links }),
  ),
  onResetFollowedPeople: () => dispatch(resetFollowedUsersActionCreator()),
  onViewPosts: () => {
    dispatch(selectFeedFilterActionCreator({
      type: 'feedgroup',
      slug: 'followed_people',
    }))

    dispatch(setShownSidebarPaneActionCreator(null))
  },
  onExplorePosts: (relation) => {
    dispatch(selectFeedFilterActionCreator({
      type: 'peergroup',
      relationId: relation.id,
    }))
  },
  onHidePopup: () => dispatch(hidePopupFeedFilterActionCreator()),
  onRegisterHideTimeout: (timeoutId) => dispatch(registerPopupFeedFilterTimeoutActionCreator(timeoutId)),
})

export const FeedFilterPeoplePopupContainer = connect<
  FeedFilterPeoplePopupStateProps,
  FeedFilterPeoplePopupDispatchProps,
  FeedFilterPeoplePopupOwnProps
>(mapStateToProps, mapDispatchToProps)(FeedFilterPeoplePopup)
